module.exports = __webpack_public_path__ + "img/doisDedos.89ef41f3.png";